<template>
  <div class="cp-wrapper">
    <div v-if="session" class="cp-menu">
      <div class="cp-menu__container" :class="{'hide-cp-menu': cartIsOpen}">
        <div v-click-outside="onClickOutside" class="cp-menu__container__content">
          <b-card class="selected-menu cp-menu__item d-flex d-md-none mb-2" @click="toggleMenu()">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center" v-if="selectedMenu">
                <img class="cp-menu__item__image" :src="sideMenuIcons[selectedMenu.type]"  alt=""/>
                <span v-html="selectedMenu.formatted_label"></span>
              </div>
              <svg class="cp-menu__item__ricon" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                <path d="M1 1L7 7L13 1" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </b-card>
          <b-card-group class="cp-menu__items d-md-flex" :class="{'d-none': hideMenu}">
            <b-card v-for="(menu, index) in sideMenus" class="cp-menu__item"
                    :class="{
                      'd-none': selectedMenu && menu.id === selectedMenu.id,
                      'd-md-flex': selectedMenu && menu.id === selectedMenu.id,
                      'selected-menu': selectedMenu && menu.id === selectedMenu.id
                    }"
                    v-bind:key="'menu'+index"
                    @click="updateSelectedMenu(menu)">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center flex-basis">
                  <img class="cp-menu__item__image" :src="sideMenuIcons[menu.type]" alt=""/>
                  <span class="cp-menu__item__name flex-basis" v-html="menu.formatted_label"></span>
                  <svg class="cp-menu__item__ricon d-none d-md-flex ml-2" xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 8 14" fill="none">
                    <path d="M1 13L7 7L0.999999 1" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
            </b-card>
          </b-card-group>
        </div>
      </div>
      <div class="cp-content" v-if="this.selectedMenu">
        <CustomerPortalHome v-if="isCustomerPortalHome" />
        <CustomerPortalOrders v-else-if="isCustomerPortalOrders"
                              :side-menus="sideMenus"
                              :input="input"
                              :selected-order="selectedOrder"
                              @submit="goToOrderHistory" @selectItem="selectItemInput"
        />
        <CustomerPortalPaymentInfo v-else-if="isCustomerPortalPaymentInfo" :input="input" />
        <CustomerPortalOrderHistory v-else-if="isCustomerPortalOrderHistory" :input="input" />
        <CustomerPortalPersonalInfo v-else-if="isCustomerPortalPersonalInfo" :input="input" @submit="goToPaymentMethods" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {InputType} from '@/constants'
import {getOrderDetail, removeOrderDetail} from '@/utils'

const CustomerPortalHome = () => import('@/components/CustomerPortal/CustomerPortalHome')
const CustomerPortalOrders = () => import('@/components/CustomerPortal/CustomerPortalOrders')
const CustomerPortalPaymentInfo = () => import('@/components/CustomerPortal/CustomerPortalPaymentInfo')
const CustomerPortalOrderHistory = () => import('@/components/CustomerPortal/CustomerPortalOrderHistory')
const CustomerPortalPersonalInfo = () => import('@/components/CustomerPortal/CustomerPortalPersonalInfo')

export default {
  name: 'CustomerPortal',
  components: {
    CustomerPortalHome,
    CustomerPortalOrders,
    CustomerPortalPaymentInfo,
    CustomerPortalOrderHistory,
    CustomerPortalPersonalInfo
  },
  props: {
    input: Object
  },
  data: function() {
    return {
      hideMenu: true,
      selectedMenu: {},
      sideMenuIcons: {
        [InputType.CustomerPortalHome]: require('@/assets/images/cp-home.svg'),
        [InputType.CustomerPortalOrderHistory]: require('@/assets/images/cp-order-history.svg'),
        [InputType.CustomerPortalOrders]: require('@/assets/images/cp-order-list.svg'),
        [InputType.CustomerPortalPaymentInfo]: require('@/assets/images/cp-payment-info.svg'),
        [InputType.CustomerPortalPersonalInfo]: require('@/assets/images/cp-personal-info.svg')
      }
    }
  },
  watch: {
    'input': {
      handler: function(val) {
        if (this.isSideMenuInput) {
          this.updateSelectedMenu(val, false)
        }
      }
    }
  },
  computed: {
    ...mapState(['session', 'cartIsOpen']),
    ...mapGetters(['isSessionUserKnown']),
    selectedOrder: function() {
      return getOrderDetail()
    },
    sideMenus: function() {
      return (this.session && this.session.side_menu_inputs) || []
    },
    isSideMenuInput: function() {
      return this.input && this.sideMenus.some((input) => input.type === this.input.type)
    },
    isCustomerPortalHome: function() {
      return this.selectedMenu.type === InputType.CustomerPortalHome
    },
    isCustomerPortalOrdersStep: function() {
      return this.session && [InputType.CustomerPortalOrders, InputType.CustomerPortalOrderDetail].indexOf(this.session.step_type) > -1
    },
    isCustomerPortalOrders: function() {
      return this.selectedMenu.type === InputType.CustomerPortalOrders ||
        this.selectedMenu.type === InputType.CustomerPortalOrderDetail
    },
    isCustomerPortalPaymentInfo: function() {
      return this.selectedMenu.type === InputType.CustomerPortalPaymentInfo
    },
    isCustomerPortalOrderHistory: function() {
      return this.selectedMenu.type === InputType.CustomerPortalOrderHistory
    },
    isCustomerPortalPersonalInfo: function() {
      return this.selectedMenu.type === InputType.CustomerPortalPersonalInfo
    },
    ordersMenu: function() {
      return this.sideMenus.find((menu) => menu.type === InputType.CustomerPortalOrders)
    }
  },
  methods: {
    goToOrderHistory: function() {
      const menu = this.sideMenus.find((menu) => menu.type === InputType.CustomerPortalOrderHistory)
      if (menu) {
        this.updateSelectedMenu(menu)
      }
    },
    goToPaymentMethods: function() {
      const menu = this.sideMenus.find((menu) => menu.type === InputType.CustomerPortalPaymentInfo)
      if (menu) {
        this.updateSelectedMenu(menu)
      }
    },
    selectItemInput: function(data) {
      this.$emit('selectItemInput', data)
    },
    submitInput: function(input) {
      if (input) {
        this.$emit('submit', input)
      }
    },
    updateSelectedMenu: function(input, submit = true) {
      if (this.selectedMenu.id !== input.id) {
        this.selectedMenu = input
        if (submit) {
          removeOrderDetail()
          this.submitInput(this.selectedMenu)
        }
      }
      this.hideMenu = true
    },
    toggleMenu: function() {
      this.hideMenu = !this.hideMenu
    },
    onClickOutside() {
      if (!this.hideMenu) {
        this.hideMenu = true
      }
    }
  },
  created() {
    if (this.selectedOrder && !this.isCustomerPortalOrdersStep) {
      removeOrderDetail()
      this.selectedMenu = this.input
    } else {
      this.selectedMenu = this.selectedOrder ? this.ordersMenu : this.input
    }
  }

}
</script>

<style scoped>

</style>
